/**
 * Created by PuTi(编程即菩提) 9/1/17.
 */

var nb = require('../../nb');
module.exports = nb.define({
    parent: require('../../page'),
    slot: {
        content: ['html', {
            $type: require('./view/Content'),
            $model:'content'
        }]
    },
    method: {
        init:function () {
            nb.model.onChange(nb.opts.clientReady,function(inEvent){
                var content = this.getModel().get('content');
                content.onChange('storyReady',function (inEvent) {
                    new Swiper ('#swiper-story', {
                        direction: 'horizontal',
                        slidesPerView:3,
                        paginationClickable: true,
                        speed:800,
                        grabCursor:true,
                        spaceBetween:50,
                        prevButton:'.swiper-button-prev',
                        nextButton:'.swiper-button-next',
                        breakpoints: {
                            1024: {
                                speed:500,
                                slidesPerView: 3,
                                spaceBetween: 40
                            },
                            768: {
                                speed:500,
                                slidesPerView: 2,
                                spaceBetween: 30
                            },
                            480: {
                                speed:500,
                                slidesPerView: 1,
                                spaceBetween: 20
                            }
                        }
                    })
                },this);
                content.onChange('bannerReady',function (inEvent) {
                    new Swiper ('#swiper-banner', {
                        auto:true,
                        pagination: '.swiper-pagination',
                        paginationClickable: true,
                        autoplay:5000,
                        speed:800,
                        onInit:function () {
                            content.set('bannerStatus','enter');
                        }
                    });
                },this);
            },this);
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/Page.js
// module id = 399
// module chunks = 1